import type { SupabaseClient } from '../../lib/supabase';
import { ConsoleConversation } from './ConsoleConversation';
import {
  loadConsoleMessages,
  markConsoleMessagesRead,
  searchConsoleMessages,
  sendConsoleMessage,
  consoleVoiceAccess,
} from './huddleApi';
import { readConsoleReactions, setConsoleReaction } from './consoleReactions';

export function ConsoleMessageSheet({
  open,
  onClose,
  client,
  token,
  initialMessageId,
}: {
  open: boolean;
  onClose: () => void;
  client: SupabaseClient;
  token: string;
  initialMessageId?: string;
}) {
  return (
    <aside className="console-message-sheet" aria-label="Private chat with Kyu" hidden={!open}>
      <ConsoleConversation
        key={token}
        open={open}
        voiceAccess={consoleVoiceAccess(client, token)}
        {...(initialMessageId ? { initialMessageId } : {})}
        phone
        title="Private chat with Kyu"
        closeLabel="Close messages"
        onClose={onClose}
        read={(cursor) =>
          loadConsoleMessages(client, token, {
            limit: 25,
            ...(cursor ? { beforeAt: cursor.created_at, beforeId: cursor.id } : {}),
          })
        }
        search={(query, cursor) => searchConsoleMessages(client, query, token, cursor)}
        markRead={() => markConsoleMessagesRead(client, token)}
        send={(body, source) => sendConsoleMessage(client, token, body, source)}
        reactions={{
          partner: 'Kyu',
          read: (ids) => readConsoleReactions(client, ids, token),
          set: (id, emoji, on) => setConsoleReaction(client, token, id, emoji, on),
        }}
      />
    </aside>
  );
}
